<template>
  <div class="filter-row d-flex align-items-center pt-2">
    <b-button
      v-for="option in typeOptions"
      :key="option.id"
      class="mr-1"
      pill
      :variant="selectedType === option.id ? 'primary' : 'light'"
      :class="{ 'inactive-filter': selectedType !== option.id }"
      :disabled="isEmpty(option.id)"
      @click="selectType(option.id)"
      size="sm"
    >
      {{ option.label }}
      <span v-if="hasCount(option.id)" class="filter-count">
        {{ counts[option.id] }}
      </span>
    </b-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typeOptions: [
        { id: 'all', label: 'All Files' },
        { id: 'pdf', label: 'PDF' },
        { id: 'spreadsheet', label: 'Spreadsheets' },
        { id: 'document', label: 'Documents' },
        { id: 'image', label: 'Images' },
      ],
    }
  },

  props: {
    selectedType: { type: String, default: 'all' },
    // Files per type chip; null when the view has no such counts.
    counts: { type: Object, default: null },
  },

  methods: {
    hasCount(typeId) {
      return !!this.counts && typeof this.counts[typeId] === 'number'
    },

    // A chip with nothing behind it is disabled, unless it is the one in use.
    isEmpty(typeId) {
      return (
        this.hasCount(typeId) &&
        this.counts[typeId] === 0 &&
        this.selectedType !== typeId
      )
    },

    selectType(typeId) {
      this.$emit('type-change', typeId)
    },
  },
}
</script>

<style scoped>
.inactive-filter {
  background-color: #e9ecef;
  border: 1px solid #dcdddd;
  color: #212529;
}

.inactive-filter:hover {
  background-color: #dee2e6;
  border-color: #adb5bd;
  color: #212529;
}

.filter-count {
  margin-left: 4px;
  opacity: 0.7;
}

.filter-row {
  gap: 2px;
}

/* The chips scroll sideways instead of wrapping or squeezing. */
@media (max-width: 767.98px) {
  .filter-row {
    flex-wrap: nowrap;
    margin-right: -4px;
    overflow-x: auto;
    padding-bottom: 4px;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .filter-row::-webkit-scrollbar {
    display: none;
  }

  .filter-row .btn {
    flex-shrink: 0;
    white-space: nowrap;
  }
}
</style>
